import script from "./SummaryLeads.vue?vue&type=script&setup=true&lang=ts"
export * from "./SummaryLeads.vue?vue&type=script&setup=true&lang=ts"

import "./SummaryLeads.vue?vue&type=style&index=0&id=2bba0aeb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bba0aeb"]])

export default __exports__